import { useQuery, useQueryClient } from 'react-query';
import { useNewsFeed } from './use-news-feed';

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

const storageKey = (gymUid, uid) => `news-feed-last-seen:${gymUid}:${uid}`;

function getNewsFeedLastSeen(gymUid, uid) {
  if (!gymUid || !uid) return 0;
  const raw = window.localStorage.getItem(storageKey(gymUid, uid));
  return raw ? Number(raw) : 0;
}

function setNewsFeedLastSeen(gymUid, uid, timestamp) {
  if (!gymUid || !uid) return;
  window.localStorage.setItem(storageKey(gymUid, uid), String(timestamp));
}

export function useNewsFeedUnreadCount(gymUid, uid) {
  const { posts } = useNewsFeed(gymUid);
  const { data: lastSeenAt = 0 } = useQuery(
    ['news-feed-last-seen', gymUid, uid],
    () => getNewsFeedLastSeen(gymUid, uid),
    { enabled: !!gymUid && !!uid }
  );

  const now = Date.now();
  const unreadCount = posts.filter((post) => {
    const createdAt = new Date(post.created_at || post.createdAt || 0).getTime();
    return now - createdAt <= WEEK_MS && createdAt > lastSeenAt;
  }).length;

  return { unreadCount };
}

export function useMarkNewsFeedSeen(gymUid, uid) {
  const queryClient = useQueryClient();

  return () => {
    if (!gymUid || !uid) return;
    const now = Date.now();
    setNewsFeedLastSeen(gymUid, uid, now);
    queryClient.setQueryData(['news-feed-last-seen', gymUid, uid], now);
  };
}
